import { render, staticRenderFns } from "./FileCardLanguages.vue?vue&type=template&id=6970bd31"
import script from "./FileCardLanguages.vue?vue&type=script&lang=js"
export * from "./FileCardLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports